<template>
    <div class="loader" :style="style" v-show="loading">
        <!-- Ugly svg-code from bcklnd -->
        <svg width="100" height="100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
            <g fill="none" fill-rule="evenodd" stroke-width="2">
                <circle cx="50" cy="50" r="1">
                    <animate attributeName="r"
                             begin="0s" dur="1.8s"
                             values="1; 50"
                             calcMode="spline"
                             keyTimes="0; 1"
                             keySplines="0.165, 0.84, 0.44, 1"
                             repeatCount="indefinite"/>
                    <animate attributeName="stroke-opacity"
                             begin="0s" dur="1.8s"
                             values="1; 0"
                             calcMode="spline"
                             keyTimes="0; 1"
                             keySplines="0.3, 0.61, 0.355, 1"
                             repeatCount="indefinite"/>
                </circle>
                <circle cx="50" cy="50" r="1">
                    <animate attributeName="r"
                             begin="-0.9s" dur="1.8s"
                             values="1; 50"
                             calcMode="spline"
                             keyTimes="0; 1"
                             keySplines="0.165, 0.84, 0.44, 1"
                             repeatCount="indefinite"/>
                    <animate attributeName="stroke-opacity"
                             begin="-0.9s" dur="1.8s"
                             values="1; 0"
                             calcMode="spline"
                             keyTimes="0; 1"
                             keySplines="0.3, 0.61, 0.355, 1"
                             repeatCount="indefinite"/>
                </circle>
            </g>
        </svg>
    </div>
</template>

<script>
  export default {
    name: 'TLoader',
    props: {
      color: String,
      loading: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        colour: this.color || 'rgba(38, 43, 66, 0.9)',
      };
    },
    computed: {
      style() {
        return `background: ${this.colour};`;
      },
    },
  };
</script>

<style lang="scss" scoped>
    .loader {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 5;
        display: flex;
        align-items: center;

        svg {
            width: 50px;
            display: block;
            margin-left: auto;
            margin-right: auto;
        }
    }
</style>
